import { ObjectsParams } from '../../types/ParamsTypes';

export const getUpdatedObjectFilterRegionsParams = (
  objectsParams: ObjectsParams,
  value: string,
): ObjectsParams => {
  if (value === 'all') {
    return { ...objectsParams, regions: [], cities: [] };
  } else {
    return { ...objectsParams, regions: [value], cities: [] };
  }
};
